import { create } from "zustand";
import { useAddInputAcknowledgementSlice } from "../slices/UserInputAcknowledgementSlices/addInputAcknSlice";
import { useFetchInputAcknowledgementSlice } from "../slices/UserInputAcknowledgementSlices/fetchInputAcknSlice";

interface UserInputAcknowledgementInterface
  extends ReturnType<typeof useFetchInputAcknowledgementSlice>,
   ReturnType<typeof useAddInputAcknowledgementSlice> {}

export const UserInputAcknowledgementStore =
  create<UserInputAcknowledgementInterface>((...a) => ({
    ...useFetchInputAcknowledgementSlice(...a),
    ...useAddInputAcknowledgementSlice(...a),
  }));
